import { render, staticRenderFns } from "./InputUploadCpt.vue?vue&type=template&id=62fc9b49&scoped=true&"
import script from "./InputUploadCpt.vue?vue&type=script&lang=ts&"
export * from "./InputUploadCpt.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62fc9b49",
  null
  
)

export default component.exports